import { useSelector } from "react-redux";
import { FaYoutube } from "react-icons/fa";
import { useResponsive } from "../../hooks/useResponsive.js";
import IsInUserList from "../../component/previews/IsInUserList.js";
import { BlackGradientToTop } from "../ui/Overlays.js";



function PreviewImage({
  media,
  type = "movie",
  children,
  posters,
  hud = true,
}) {
  const token = useSelector((state) => state.auth.token);
  const { isMD } = useResponsive();
  const imgPath = media.thumbnail || "";
  const hasImage = Boolean(imgPath);
  const backgroundImage = hasImage ? `url(${imgPath})` : undefined;
  const displayTitle = media.title || media.name || media.description || "";
  const displayDescription = media.description && media.description !== displayTitle ? media.description : "";
  const showYoutubeBadge = media.type === "youtube";
  const youtubeIconSize = isMD ? 26 : 20;
console.log("Posters in PreviewImage:", media);
  return (
    <div className="w-full">
      <div className="relative w-full overflow-hidden rounded-2xl group">
        <div
          style={{ backgroundImage }}
          className={`absolute inset-0 bg-center bg-cover transition-transform duration-300 group-hover:scale-95
    rounded-2xl transform-gpu will-change-transform
    ${hasImage ? "" : "bg-stone-900 flex items-center justify-center"}`}
        >
          {children}

          {!hasImage && (
            <div
              className="relative w-full px-4"
              style={
                type === "tv"
                  ? {
                    padding: isMD ? "2.5rem .5rem .5rem" : "2.5rem 1.5rem .75rem",
                  }
                  : {}
              }
            >
              <BlackGradientToTop height="80%" />
              <h3 className="relative z-10 font-montserrat font-bold text-white text-lg md:text-xl line-clamp-2">
                {displayTitle}
              </h3>
            </div>
          )}

          {hud && token && <IsInUserList id={media.id} />}

          {showYoutubeBadge && (
            <div className="absolute bottom-3 right-3">
              <span className="flex items-center justify-center rounded-full bg-white/90 p-1.5 text-[#FF0000] shadow-md backdrop-blur">
                <FaYoutube size={youtubeIconSize} />
              </span>
            </div>
          )}
        </div>
        <div className="pt-[56.25%]" />
      </div>

      {(displayTitle || displayDescription) && (
        <div className="mt-3 space-y-1 px-1">
          {displayTitle && (
            <h3 className="font-montserrat font-bold text-white text-lg leading-tight line-clamp-2">
              {displayTitle}
            </h3>
          )}
          {/* {displayDescription && (
            <p className="text-sm text-white/70 leading-snug line-clamp-2">{displayDescription}</p>
          )} */}
        </div>
      )}
    </div>
  );
}

export default PreviewImage;
